import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { FOUNDING_REPORT_QUERY_KEY } from "./constants";
import { fetchFoundingReport } from "./founding-api";
import type { FoundingReportFilters } from "./types";

export function useFoundingReport(filters: FoundingReportFilters) {
  return useQuery({
    queryKey: [
      ...FOUNDING_REPORT_QUERY_KEY,
      filters.country.trim().toUpperCase(),
      filters.tier.trim(),
    ] as const,
    queryFn: () => fetchFoundingReport(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
